(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();






















var Avatar = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"inline-block ml-3 mt-1 w-3 account-dropdown-arrow"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.429 7.428"}},[_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"Symbol_382","data-name":"Symbol 382","transform":"translate(-1817.5 -25.5)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Pfad_24","data-name":"Pfad 24","d":"M11.429,11.714a.686.686,0,0,1-.212.5l-5,5a.7.7,0,0,1-1,0l-5-5a.7.7,0,0,1,0-1A.686.686,0,0,1,.714,11h10a.724.724,0,0,1,.714.714Z","transform":"translate(1818 15)"}})])])]),_vm._v(" "),(_vm.avatar.has_avatar)?_c('img',{staticClass:"account-dropdown__account-image",attrs:{"src":_vm.assetPath + _vm.avatar.file_name,"alt":""}}):_c('span',{staticClass:"user-administration-nameholder"},[_vm._v(_vm._s(_vm.initials))])])},staticRenderFns: [],
  props: {
    avatar: {
      type: Object,
      required: true
    },
    initials: {
      type: String,
      default: ''
    },
    assetPath: {
      type: String,
      default: ''
    }
  }
};

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=""; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();

var component = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-administration-flyouts"}},[_c('div',{attrs:{"id":"user-administration"},on:{"click":function($event){_vm.visible=!_vm.visible;}}},[_c('a',{staticClass:"account-dropdown__menu",class:{'cursor-pointer': !_vm.company || _vm.company && _vm.activeAccountClickable },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('toggle');}}},[_c('avatar',{attrs:{"avatar":_vm.user.avatar,"initials":_vm.user.initials,"asset-path":_vm.assetPath}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"top--bar-flyout",style:({color: _vm.colors.primary}),attrs:{"id":"user-administration-flyout"}},[_c('ul',[_c('li',[_c('h4',{staticClass:"m-0 small-eg-primary text-uppercase font-weight-bold m-0",style:({color: _vm.colors.primary})},[_vm._v(_vm._s(_vm.text.activeAccounts))]),_vm._v(" "),(!_vm.company)?_c('a',{staticClass:"account-dropdown__menu-item",class:_vm.classes.link,style:({color: _vm.getLinkColor}),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('linkClick', _vm.paths.profile);}}},[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))]):_c('div',{staticClass:"user-accounts-link cursor-pointer pb-2"},[(_vm.activeAccountClickable)?_c('a',{staticClass:"account-dropdown__menu-item",class:_vm.classes.link,style:({color: _vm.getLinkColor}),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('linkClick', _vm.paths.company);}}},[_vm._v(_vm._s(_vm.company.name))]):_vm._e(),_vm._v(" "),(_vm.activeAccountClickable)?_c('div',{staticClass:"user-accounts-avatar"},[(_vm.company.avatar)?_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$emit('linkClick', _vm.paths.company);}}},[_c('img',{attrs:{"src":_vm.assetPath + _vm.company.avatar}})]):_c('a',{style:({color: _vm.getInitialsColor}),on:{"click":function($event){$event.preventDefault();_vm.$emit('linkClick', _vm.paths.company);}}},[_vm._v(_vm._s(_vm.initials(_vm.company.name)))])]):_vm._e(),_vm._v(" "),(!_vm.activeAccountClickable)?_c('span',{staticClass:"account-dropdown__menu-item no-hover",class:_vm.classes.link,style:({color: _vm.getLinkColor})},[_vm._v(_vm._s(_vm.company.name))]):_vm._e(),_vm._v(" "),(!_vm.activeAccountClickable)?_c('div',{staticClass:"user-accounts-avatar no-hover"},[(_vm.company.avatar)?_c('img',{attrs:{"src":_vm.assetPath + _vm.company.avatar}}):_c('span',{style:({color: _vm.getInitialsColor})},[_vm._v(_vm._s(_vm.initials(_vm.company.name)))])]):_vm._e(),_vm._v(" "),(_vm.company.location_city)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.company.location_city)+", "+_vm._s(_vm.countries[_vm.company.location_country])+" ")]):_vm._e()])]),_vm._v(" "),(_vm.accounts.length)?_c('li',[_c('h4',{staticClass:"m-0 small-eg-primary text-uppercase font-weight-bold pb-1",style:({color: _vm.primaryColor})},[_vm._v(_vm._s(_vm.text.otherAccounts))]),_vm._v(" "),_vm._l((_vm.accounts),function(ref){
var id = ref.id;
var name = ref.name;
var avatar = ref.avatar;
var location_city = ref.location_city;
var location_country = ref.location_country;
return _c('div',{key:id,staticClass:"user-accounts-link cursor-pointer pb-2"},[_c('a',{staticClass:"account-dropdown__menu-item",class:_vm.classes.link,style:({color: _vm.getLinkColor}),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('switch', id);}}},[_vm._v(_vm._s(name))]),_vm._v(" "),_c('div',{staticClass:"user-accounts-avatar"},[(avatar)?_c('a',{on:{"click":function($event){$event.preventDefault();_vm.$emit('switch', id);}}},[_c('img',{attrs:{"src":_vm.assetPath + avatar}})]):_c('a',{style:({color: _vm.getInitialsColor}),on:{"click":function($event){$event.preventDefault();_vm.$emit('switch', id);}}},[_vm._v(_vm._s(_vm.initials(name)))])]),_vm._v(" "),(location_city)?_c('p',{staticClass:"mb-0 account-dropdown__pr-5"},[_vm._v(" "+_vm._s(location_city)+", "+_vm._s(_vm.countries[location_country])+" ")]):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('li',[_vm._t("default"),_vm._v(" "),_c('a',{staticClass:"account-dropdown__menu-item",class:_vm.classes.link,style:({color: _vm.getLinkColor}),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('linkClick', _vm.paths.settings);}}},[_vm._v(_vm._s(_vm.text.settings))]),_vm._v(" "),_c('a',{staticClass:"cursor-pointer account-dropdown__menu-item",class:_vm.classes.link,style:({color: _vm.getLinkColor}),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('logout');}}},[_vm._v("Logout")])],2)])])])])},staticRenderFns: [],
  name: 'AccountDropdown',
  components: { Avatar: Avatar },
  props: {
    user: {
      type: Object,
      required: true,
    },
    accounts: {
      type: Array,
      default: function () { return []; }
    },
    company: {
      type: Object,
      default: null
    },
    paths: {
      type: Object,
      default: function () { return ({
        profile: 'profile',
        company: 'company',
        settings: 'settings',
      }); }
    },
    text: {
      type: Object,
      default: function () { return ({
        activeAccounts: 'Active Accounts',
        otherAccounts: 'Other accounts',
        settings: 'Settings',
      }); }
    },
    colors: {
      type: Object,
      default: function () { return ({
        primary: '#54828E',
        link: '',
        initials: '',
      }); }
    },
    classes: {
      type: Object,
      default: function () { return ({
        link: ''
      }); }
    },
    countries: {
      type: Object,
      default: function () { return ({
        us: 'USA',
        de: 'Germany'
      }); }
    },
    assetPath: {
      type: String,
      default: ''
    },
    activeAccountClickable: {
      type: Boolean,
      default: false
    }
  },

  data: function data () {
    return {
      visible: false
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$el.addEventListener('click', function (event) { return event.stopPropagation(); } );
    this.$el.addEventListener('touchend', function (event) {
      event.stopPropagation();
     } );
    document.body.addEventListener('click', function () { return this$1.visible = false; });
    document.body.addEventListener('touchend', function () {
      this$1.visible = false;
      });

    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        this$1.visible = false;
      }
    };
  },

  watch: {
    visible: function visible() {
      this.$emit('changed', this.visible);
    }
  },

  beforeDestroy: function beforeDestroy () {
    var this$1 = this;

    this.$el.removeEventListener('click', function (event) { return event.stopPropagation(); });
    document.body.removeEventListener('click', function () { return this$1.visible = false; });
    document.body.removeEventListener('touchstart', function () { return this$1.visible = false; });
    document.onkeydown = null;
  },

  computed: {
    getLinkColor: function getLinkColor () {
      return this.colors.link || this.colors.primary;
    },
    getInitialsColor: function getInitialsColor () {
      return this.colors.initials || this.colors.primary;
    }
  },
  methods: {
    initials: function initials(name) {
      return name.split(' ').reduce(function (acc, cur) { return acc + cur[0].toUpperCase(); }, '').slice(0,2)
    }
  }
};

// Import vue component

// install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return; }
	install.installed = true;
	Vue.component('AccountDropdown', component);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// To auto-install when vue is found
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default component;
export { install };
